<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
            <div>
                <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
                </button>

                <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                  <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
                </button>
            </div>
          <div class="d-flex">
            <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-primary mb-0 hover-cursor">&nbsp;Lessee</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <h5 class="card-title mb-4">Lessee </h5>
                <div class="search-table container-fluid">
                  <div class="row">
                    <!-- <div class="col-lg-4 col-sm mobile-div">
                      <input type="text" class="form-control form-control-sm" v-model="orderId" placeholder="Order ID">
                    </div> -->
                    <div class="col-lg-3 col-sm mobile-div">
                      Company Name
                      <input type="text" class="form-control" v-model="companyName" placeholder="Company Name">
                    </div>
                    <div class="col-lg-3 col-sm mobile-div">
                      Join Date (from)
                      <input type="date" class="form-control" v-model="inputJoinFrom" placeholder="Company Name">
                    </div>
                    <div class="col-lg-3 col-sm mobile-div">
                      Join Date (to)
                      <input type="date" class="form-control" v-model="inputJoinTo" placeholder="Company Name">
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-sm mobile-div">
                      Company Status
                        <multiselect v-model="searchStatus" :options="statusSelect" label="statusName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="statusName" :multiple="true" :taggable="true" :close-on-select="false" group-values="libs" group-label="statusAll" :group-select="true"></multiselect>
                    </div>
                    <div class="col-lg-3 col-sm mobile-div">
                      Sales Status
                        <multiselect v-model="searchSalesStatus" :options="salesStatusSelect" label="statusName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="statusName" :multiple="true" :taggable="true" :close-on-select="false" group-values="libs" group-label="statusAll" :group-select="true"></multiselect>
                    </div>
                    <div class="col-lg-3 col-sm mobile-div">
                      Asani PIC
                        <multiselect v-model="searchPic" :options="picSelect" label="employeeName" :allow-empty="true" :select-label="''" :deselect-label="''" placeholder="All" track-by="employeeName" :multiple="true" :taggable="true" :close-on-select="false" group-values="libs" group-label="statusAll" :group-select="true"></multiselect>
                    </div>
                    <!-- <div class="col-lg-2 col-sm mobile-div">
                      <select class="form-control form-control-sm" data-toggle="dropdown" name="status" v-model="statusOrder" >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div> -->
                    <div class="col-lg-2 col-sm mobile-div mt-4">
                      <button class="btn btn-primary" @click="searchData"> Search </button>
                    </div>
                  </div>
                </div>
                <button class="btn btn-sm btn-primary mb-1" @click="openModal('Add')"> Add </button>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th style="width: 380px">Company Name</th>
                      <th style="width: 170px;">Tag</th>
                      <th style="width: 100px;">Join Date</th>
                      <th style="width: 139px;">On Renting (Qty)</th>
                      <th >Company Status</th>
                      <th >Sales Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable == true">
                      <td colspan="6" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-else-if="loadingTable == false && totalData == 0">
                      <td colspan="6" class="text-center"> Data not available</td>
                    </tr>
                    <tr v-for="data in dataLessee" :key="data.lesseeId" v-else>
                      <td>
                        <router-link 
                          :to="{
                            path:'/partnership/lessee/detail/' + data.companyId, 
                            query: {
                              companyStatus : data.status
                            }
                          }"
                        >
                          {{ data.companyName }}
                        </router-link>
                      </td>
                      <!-- <td> 
                        <span  class="badge badge-secondary">Lessee Tag {{data.lesseeId}}</span>
                        <button  type="button" class="btn btn-primary btnEdit-sm" @click="openUpdateTagModal(data.leseeId, data.lesseeTag)"><img src="~@/assets/icon/edit.png" style="max-width:12px;"/></button>
                      </td> -->
                      
                      <td>
                        <div class ='tagColumn' v-for="tag in data.lesseeTag" :key="tag.tagId">
                          <div>
                            <span class = 'tagBadge' :style="'background-color :'+tag.colorHex+';' ">{{tag.label}}</span>
                          </div>
                        </div> 
                        <button  v-if="allowUpdateLesseeTag" type="button" class="btn btn-primary btnEdit-sm" @click="openUpdateTagModal(data, data.currentTags)"><img src="~@/assets/icon/edit.png" style="max-width:12px;"/></button>
                      </td>
                      <td>{{ data.joinDate }}</td>
                      <td>{{ data.Qty }}</td>
                      <td>
                        <span v-if="data.companyStatus == 0" class="badge badge-secondary">Pending</span>
                        <span v-if="data.companyStatus == 1" class="badge badge-warning">Trying to Contact</span>
                        <span v-if="data.companyStatus == 2" class="badge badge-warning">Waiting for Meeting</span>
                        <span v-if="data.companyStatus == 3" class="badge badge-warning">Waiting for Documents</span>
                        <span v-if="data.companyStatus == 4" class="badge badge-warning">Waiting for Documents Verification</span>
                        <span v-if="data.companyStatus == 5" class="badge badge-warning">Agreement Ready to Send</span>
                        <span v-if="data.companyStatus == 6" class="badge badge-warning">Waiting for Agreement Response</span>
                        <span v-if="data.companyStatus == 7" class="badge badge-warning">Waiting for Verification Result</span>
                        <span v-if="data.companyStatus == 8" class="badge badge-success">Verified</span>
                        <span v-if="data.companyStatus == 99" class="badge badge-danger">Rejected</span>
                      </td>
                      <td>
                        <span v-if="data.salesStatus == 0" class="badge badge-warning">On Hold</span>
                        <span v-if="data.salesStatus == 1" class="badge badge-success">On Prospect</span>
                        <span v-if="data.salesStatus == 2" class="badge badge-primary">On Going</span>
                        <span v-if="data.salesStatus == null" class="badge badge-secondary">None</span>
                      </td>
                      <td>
                        <button class="btn btn-primary btn-sm" @click="handleImportAsset(data)" > Import Asset </button>
                      </td>
                      <!-- <td><button class="btn btn-primary btn-sm" @click="toDetail(data.companyId, data.status)"> Detail </button></td> -->
                    </tr>
                  </tbody>
                </table>
                <!-- Hidden input and button file for import assets -->
                <input type="file" ref="inputFileAsset" hidden @change="handlePickAssetFile" >
                <button @click="handleClickHiddenButton" hidden ref="hiddenImportAssetButton" ></button>
                <!-- End Hidden input file for import assets -->
                <div id="wrapperr">
                  <div id="c1">
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <!-- modalAddEmployee -->
      <div class="modal fade" id="modalAdd" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <div class="change-title">
                        <h4 class="modal-title">Add New Lessee </h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="one-line">
                        <label class="ol-label"> Company Name </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="name" class="form-control" v-model="addCompanyName">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> PIC Name </label>
                        <label class="ol-titik2">:</label>
                        <input type="email" name="email" class="form-control" v-model="picName">
                    </div>
                    <div class="one-line">
                        <label class="ol-label"> PIC Phone </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="phone_number" class="form-control"  v-model.trim="phoneNumber" @keypress="isNumber($event)" placeholder="">
                    </div>
                    <div class="one-line">
                                <label class="ol-label"> PIC Division </label>
                                <label class="ol-titik2">:</label>
                                <input type="name" name="name" class="form-control" v-model="addDivision" >
                            </div>
                            <div class="one-line">
                                <label class="ol-label"> PIC Position </label>
                                <label class="ol-titik2">:</label>
                                <input type="name" name="name" class="form-control" v-model="addPosition" >
                            </div>
                    <div class="one-line">
                        <label class="ol-label"> Source </label>
                        <label class="ol-titik2">:</label>
                        <multiselect v-model="source" :options="sourceSelect"  :allow-empty="false" label="sourceName" track-by="sourceId" :select-label="''" :deselect-label="''" placeholder="Source" style="height: 5px;"></multiselect>
                    </div>
                    <div class="one-line" v-if="source == 'Other'">
                        <label class="ol-label">New Source </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="new_source" class="form-control" v-model="newSource">
                    </div>
                    <div class="one-line" v-if="source == 'Network'">
                        <label class="ol-label">Employee Name </label>
                        <label class="ol-titik2">:</label>
                        <input type="text" name="emploee_name" class="form-control" v-model="employeeSource">
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
                    <button type="button" class="btn btn-primary btn-sm" @click="addNewLeesee" v-if="loadingButtonAdd == false">Save</button>
                    <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Save</button>
                </div>
            </div>
        </div>
      </div>
      <!-- endModal -->

      <!-- modalEditLesseeTag -->
      <div class="modal fade" id="modalEditLesseeTag" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Edit Tag </h4>
              </div>
              <button type="button" class="close" data-dismiss="modal" @click="cancelUpdateTag()">&times;</button>
            </div>
            <div class="modal-body">
              <div v-for="data in dataTag" :key="data.categoryId">
                <div class="row g-3 align-items-center">
                  <div class="col-2">
                    <label for="editTags" class="col-form-label">{{data.categoryName}}</label>
                  </div>
                  <div class="col-10">
                    <multiselect v-model="selectedTag[data.categoryName]" :options="data.tag" label="label" :allow-empty="true" :multiple="true" :select-label="''" :deselect-label="''" track-by="label" :close-on-select="false"></multiselect>
                  </div>
                </div>
              </div>
              
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="cancelUpdateTag()">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitUpdatedLesseeTag()" v-if="loadingButtonAdd == false">Save</button>
              <button type="button" class="btn btn-primary btn-sm" disabled v-else><img src="~@/assets/images/2.gif" style="height: 24px;">Saving</button>
            </div>
          </div>
        </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import swal from 'sweetalert'
import SideBar from '../SideBar'
export default {
  name: 'ResolutionCenterPage',
  components:{
    SideBar,
    Multiselect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      source:"",
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      allowUpdateLesseeTag: false,
      dataLessee: [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      orderId:"",
      companyName:"",
      addCompanyName:"",
      addDivision:"",
      addPosition:"",
      picName:"",
      phoneNumber:"",
      statusOrder:"",
      loadingTable:true,
      loadingButtonAdd:false,
      adminId:"",
      sourceSelect:[],
      newSource:'',
      employeeSource:'',
      searchStatus:[],
      statusSelect:[{
          statusAll:'All',
          libs:[{
            status:'0',
            statusName:'Pending'
          },{
            status:'1',
            statusName:'Trying to Contact'
          },{
            status:'2',
            statusName:'Waiting for Meeting'
          },{
            status:'3',
            statusName:'Waiting for Documents'
          },{
            status:'4',
            statusName:'Waiting for Documents Verification'
          },{
            status:'5',
            statusName:'Agreement Ready to Send'
          },{
            status:'6',
            statusName:'Waiting for Agreement Response'
          },{ 
            status:'7',
            statusName:'Waiting for Verification Result'
          },{ 
            status:'8',
            statusName:'Verified'
          },{
            status:'99',
            statusName:'Rejected'
          }]
      }],
      searchSalesStatus:[],
      salesStatusSelect:[{
          statusAll:'All',
          libs:[{
            status:'0',
            statusName:'On Hold'
          },{
            status:'1',
            statusName:'On Prospect'
          },{
            status:'2',
            statusName:'On Going'
          },{
            status:'None',
            statusName:'None'
          }]
      }],
      searchPic:[],
      picSelect:[{
          statusAll:'All',
          libs:[]
      }],
      inputJoinFrom:'',
      inputJoinTo:'',
      selectedLessee:{},
      dataTag:[],
      selectedTag:[],
      oldTags:[],
      companyIdToUploadAsset:null,
      assetFileToSend:null,
    }
  },
  methods: {
    sendLog(w,x){
        var today = new Date();
        var month = today.getMonth()+1
        if (month < 10) {
            month = '0'+month
        }
        var dateDay = today.getDate()
        if (dateDay < 10) {
            dateDay = '0'+dateDay
        }
        var hours = today.getHours()
        if (hours < 10) {
            hours = '0'+hours
        }
        var minutes = today.getMinutes()
        if (minutes < 10) {
            minutes = '0'+minutes
        }
        var second = today.getSeconds()
        if (second < 10) {
            second = '0'+second
        }
        var date = today.getFullYear()+'-'+month+'-'+dateDay;
        var time = hours + ":" + minutes + ":" + second;
        var dateTime = date+' '+time;
        var admin = this.admin
        var command = 'add-logs'
        // var productName = this.productNameChoose
        
        this.$http.post(process.env.LOG_URL+"/company/"+x,{
            codeLogs: w,
            params: [],
        },{
            headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
        })
        .catch(error => {
            console.log(error)
        })
    },
    addNewLeesee(){
      let source = this.source.sourceName
      if (this.addCompanyName == '') {
        swal("Sorry", "company name must be fill", "error", {
            button: "Ok",
        })
      }else if(this.picName == ''){
        swal("Sorry", "PIC name must be fill", "error", {
            button: "Ok",
        })
      }else if (this.phoneNumber == '') {
        swal("Sorry", "Phone Number must be fill or wrong format", "error", {
            button: "Ok",
        })
      }else if(this.source == ''|| (this.source.sourceName == 'Other' && this.newSource=='') || (this.source.sourceName == 'Network' && this.employeeSource=='')){
        swal("Sorry", "Source must be fill", "error", {
            button: "Ok",
        })
      }else{
        if (source == 'Other') {
          source = this.newSource
        }else if (source == 'Network') {
          source = 'Network - '+this.employeeSource
        }
        this.loadingButtonAdd = true
        const payload = {
          companyName: this.addCompanyName !== null ? this.addCompanyName.replace(this.spaceRegex, ' ') : this.addCompanyName,
          picName: this.picName !== null ? this.picName.replace(this.spaceRegex, ' ') : this.picName,
          phoneNumber: this.phoneNumber !== null ? this.phoneNumber.replace(this.spaceRegex, ' ') : this.phoneNumber,
          position:this.addPosition !== null ? this.addPosition.replace(this.spaceRegex, ' ') : this.addPosition,
          division:this.addDivision !== null ? this.addDivision.replace(this.spaceRegex, ' ') : this.addDivision,
          source: source,
          adminId: this.adminId
        }
        this.$http.post(process.env.ADD_LESSEE,payload,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 417) {
            $('#modalAdd').modal('hide')
            this.loadingButtonAdd = false
              return swal("Sorry", response.data.message , "error", {
                button: "Ok",
              }).then(v => {
                $('#modalAdd').modal('show')
              })
          }
          if (response.data.status == 400) {
              swal("Sorry", response.data.message , "error", {
                button: "Ok",
              })
          }else if (response.data.status == 201) {
              swal("Sorry", response.data.message , "error", {
                button: "Ok",
              })
          }else if (response.data.status == 200) {
              swal("Success", response.data.message , "success", {
                button: "Ok",
              })
              if (response.data.data.newData == false) {
                this.sendLog(59,response.data.data.companyId)
              }else{
                this.sendLog(46,response.data.data.companyId)
              }
          }
          $('#modalAdd').modal('hide')
          this.getData()
          this.loadingButtonAdd = false
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        }) 
      }
    },
    isNumber: function(evt) {
          evt = (evt) ? evt : window.event;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();;
          } else {
            return true;
          }
    },
    searchData(){
      this.$router.push({path:'/partnership/lessee', query: {
            companyName: this.companyName,
            statusLessee: JSON.stringify(this.searchStatus),
            salesStatus: JSON.stringify(this.searchSalesStatus),
            picLessee: JSON.stringify(this.searchPic),
            joinLesseeFrom: this.inputJoinFrom,
            joinLesseeTo: this.inputJoinTo,
            page:1
        }
      })
      this.getData()
    },
    toDataPage(pagePost){
      this.loadingTable = true
      this.$router.push({path:'/partnership/lessee', query: {
            companyName: this.companyName,
            statusLessee: JSON.stringify(this.searchStatus),
            salesStatus: JSON.stringify(this.searchSalesStatus),
            picLessee: JSON.stringify(this.searchPic),
            joinLesseeFrom: this.inputJoinFrom,
            joinLesseeTo: this.inputJoinTo,
            page:pagePost
        }
      })
      this.getData()
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
        if( this.permission[i] == '9.3'){
          this.allowUpdateLesseeTag = true
        }
        
      }
      if (this.viewLessee == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id,status){
      this.$router.push({path:'/partnership/lessee/detail/' + id, query: {
            companyStatus: status,
        }
      })
    },
    openModal(x) {
        this.addCompanyName = '',
        this.picName = ''
        this.phoneNumber = ''
        this.source = ''
        this.employeeSource = ''
        this.addPosition = ''
        this.addDivision = ''
        $("#modal"+x).modal('show')
    }, 
    openUpdateTagModal(lessee, currentTags) {
      this.selectedLessee = lessee  
      this.oldTags = {...currentTags}
      this.selectedTag = currentTags
      $("#modalEditLesseeTag").modal({backdrop: "static"})
      $("#modalEditLesseeTag").modal('show')
    },
    cancelUpdateTag() {
      this.selectedLessee.currentTags = {...this.oldTags}
    },
    sortTag(lesseeTags) {
      let result = {}
      if(lesseeTags) {
        let n = 0
        while(n < lesseeTags.length) {
          for(let i = 0; i < this.dataTag.length; i++) {
            if(this.dataTag[i].tag.find(e => e.tagId == lesseeTags[n].tagId)) { 
              if(!result[this.dataTag[i].categoryName]) {
                result[this.dataTag[i].categoryName] = [lesseeTags[n]]
              }else {
                result[this.dataTag[i].categoryName].push(lesseeTags[n])
              }
              break;
            }
          }
          n++
        }
        
      }
      
      return result
    },
    getData(){
      this.loadingTable = true
      this.dataLessee.length = 0
      this.searchStatus = []
      this.searchStatus = JSON.parse(this.$route.query.statusLessee)
      var status = []
      for (var i = 0; i < this.searchStatus.length; i++) {
        status.push(this.searchStatus[i].status)
      }
      this.searchSalesStatus = []
      this.searchSalesStatus = JSON.parse(this.$route.query.salesStatus)
      var salesStatus = []
      for (var i = 0; i < this.searchSalesStatus.length; i++) {
        salesStatus.push(this.searchSalesStatus[i].status)
      }
      this.searchPic = []
      this.searchPic = JSON.parse(this.$route.query.picLessee)
      var pic = []
      for (var i = 0; i < this.searchPic.length; i++) {
        pic.push(this.searchPic[i].id)
      }
      this.inputJoinTo = this.$route.query.joinLesseeTo
      this.inputJoinFrom = this.$route.query.joinLesseeFrom
      this.companyName = this.$route.query.companyName
      this.currentPage = parseInt(this.$route.query.page)
      this.getLesseeTag()
      this.$http.post(process.env.SEARCH_LESSEE,{
        companyName: this.companyName !== null ? this.companyName.replace(this.spaceRegex, ' ') : this.companyName,
        dateFrom: this.inputJoinFrom,
        dateTo: this.inputJoinTo,
        status: status,
        salesStatus: salesStatus,
        pic: pic,
        page: this.$route.query.page,
        itemPerPage:10
        
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}, 
        timeout: 3000 * 1000
      })
      .then(response => {
        let rawData = response.data.content.data
        for (var i = 0; i < rawData.length; i++) {
          
          let sortedTag = this.sortTag(rawData[i].lesseeTag)
          this.dataLessee = [...this.dataLessee,{...rawData[i], currentTags : sortedTag}]
        }
        this.totalPage = response.data.content.totalPage
        this.totalData = response.data.content.totalData
        this.currentPage = response.data.content.currentPage
        this.loadingTable = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
      })

      this.$http.get(process.env.GET_ALL_EMPLOYEE
        ,{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
            if (response.data.status == 200) {
                this.picSelect[0].libs = response.data.content
                this.picSelect[0].libs.push({
                  id:'-1',
                  employeeName:'None'
                })
            }
        })
        .catch(error => {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          }).then(v => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })

      this.$http.get(process.env.GET_LESSEE_SOURCE,{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
              this.sourceSelect = response.data.data
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    getLesseeTag(){
      this.$http.post(process.env.GET_TAG,
      {
        groupBy: "category",
        target: "LESSEE"
      },
      {
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })
            }else{
              this.dataTag = response.data.content.sort(function(a, b){return a.categoryId - b.categoryId})

              this.dataTag.forEach(item => {
                this.selectedTag.push({categoryName:item.categoryName, tags: item.tag}) 
              })
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    submitUpdatedLesseeTag (){
      let newTags = []
      for(const key in this.selectedTag) {
        this.selectedTag[key].forEach(item => {
          newTags.push(item.tagId)
        })
      }
      
      this.$http.post(process.env.UPDATE_LESSEE_TAG,{
            companyId: this.selectedLessee.companyId,
            tags: newTags,
            companyStatus: this.selectedLessee.status
        },{
          headers: {'Asani-Token':localStorage.getItem('jwt')}
        })
        .then(response => {
          if (response.data.status == 400) {
            swal("Sorry", "tag already exists", "error", {
              button: "Ok",
            })
          }else{
            $('#modalEditLesseeTag').modal('hide')
            swal("Success", response.data.message, "success", {
              button: "Ok",
            })
            this.getData()
          }
          this.loadingButtonAdd = false
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    handleImportAsset(data) {
      // console.log(data)
      this.companyIdToUploadAsset = data.companyId
      this.$refs.inputFileAsset.click()
      console.log("see here")
    },
    async handleClickHiddenButton() {
      this.$http.post(process.env.IMPORT_ASSET_FILE,{
        companyId: this.companyIdToUploadAsset,
        base64: this.assetFileToSend,
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status !== 200) {
          swal("Error", response.data.message || "Error uploading the asset file", "error")
        } else {
          if (response.data.content) {
            var mediaType="data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            var a = document.createElement('a');
            a.href = mediaType+response.data.content;
            a.download = `ImportAssets.xlsx`;
            a.textContent = 'Download file!';
            a.click()
            swal("Error", "There are error field in the file, please kindly check the file we send to you", "error")
          } else {
            swal("Success", "Asset successfully imported","success")
          }
        }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    async handlePickAssetFile(e) {
      const file = e.target.files[0]
      e.target.value = ""
      try {
        const sentFile = await this.toBase64(file)
        swal("Upload Asset File", `Are you sure you want to upload ${file.name}?`, "warning",{
          buttons:["Cancel", "Yes"]
        }).then(el=>{
          if (el) {
            this.assetFileToSend = sentFile
            this.$refs.hiddenImportAssetButton.click()
          }
        })
      }catch(err) {
        swal("Error", "Error when getting the file, please try again!", "error")
      }
    },
    toBase64(file) {
      return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.replace('data:', '').replace(/^.+,/, ''));
        reader.onerror = error => reject(error);
      })
    }
  },
  created(){
    this.getData()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .table thead th {
    text-align: center;
    vertical-align: middle;
  }

  .btnEdit-sm {
    font-size: 0.875rem;
    line-height: 1.5;
    padding: 0rem 0.25rem;
    border-radius: 0.2rem;
  }

  /* tag design */
  .tagColumn {
    display: inline-block;
  }

  .tagBadge {
    display: inline-block;
    padding: 0.25em 0.4em;
    font-size: 75%;
    font-weight: 700;
    line-height: 1;
    text-align: center;
    white-space: nowrap;
    vertical-align: baseline;
    border-radius: 0.25rem;
    transition: color .15s;
    margin-right: 2px;
    color: #fff;
  }

  .one-line .ol-titik2{
    width: 15px;
    margin: 2px 0px;
  }
  .one-line .ol-label{
    width: 188px;
    margin: 2px 0px;
  }
  .one-line{
    display: flex;
    margin: 5px 0px;
  }
  .pagination{
  padding: 0px 0;
  }

  .pagination ul{
  margin: 0;
  padding: 0;
  list-style-type: none;
  }

  .pagination a{
  display: inline-block;
  padding: 1px 6px;
  color: #222;
  }

  .p8 a{
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
  }

  .p8 a:hover{
  text-decoration: none;
  }
  .p8 a.page:hover{
  text-decoration: none;
  color: #fff;
  }

  .p8 .is-active{
  background-color: #fff;
  color: #2797FB;
  }

  .alignleft {
  float: left;
  }
  .alignright {
  float: right;
  }

  .pagg{
  display: inline-flex;
  overflow:auto;
  }

  .total-data{
  padding: 11px 0px;
  font-size: 14px;
  color: #343A40;
  }
  #wrapperr{
    overflow:auto;
    margin: 5px 3px;
  }

  #c1{
   float:left;
  }

  #c2{
  float: right;  
  }

  .search-table{
  padding-bottom: 7px;
  margin-top: -5px;
  margin-left: -15px;
  }
  .active{
  color: #2797FB;
  }
  .right-dropdown{
  margin-left: 7px;
  }
  .account-div{
  margin: 2px 2px;
  }
  .right-arrow{
  margin-left: auto;
  }
  .brand-logo{
  width: 120px;
  }
  .menu-title{
  margin-left: 1.125rem;
  }
  .menu-title-order{
  margin-left: 1.95rem;
  }
  .menu-title-payment{
  margin-left: 1.525rem;
  }

  ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  /*width: 200px;*/
  /*background-color: #f1f1f1;*/
  }

  li.sidebar a {
  display: block;
  color: #000;
  padding: 8px 63px;
  text-decoration: none;
  }

  li a.active {
  background-color: #4CAF50;
  color: white;
  }

  li a:hover:not(.active) {
  background-color: #2797FB;
  color: white;
  }
  .nav-side-menu {
  overflow: auto;
  font-family: verdana;
  font-size: 12px;
  font-weight: 200;
  background-color: #2e353d;
  position: fixed;
  top: 0px;
  width: 300px;
  height: 100%;
  color: #e1ffff;
  }
  .nav-side-menu .brand {
  background-color: #23282e;
  line-height: 50px;
  display: block;
  text-align: center;
  font-size: 14px;
  }
  .nav-side-menu .toggle-btn {
  display: none;
  }
  .nav-side-menu ul,
  .nav-side-menu li {
  list-style: none;
  padding: 0px;
  margin: 0px;
  line-height: 35px;
  cursor: pointer;
  }
   .nav-side-menu ul :not(collapsed) .arrow:before,
   .nav-side-menu li :not(collapsed) .arrow:before {
    font-family: FontAwesome;
    content: "\f078";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu ul .active,
  .nav-side-menu li .active {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
  }
  .nav-side-menu ul .sub-menu li.active,
  .nav-side-menu li .sub-menu li.active {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li.active a,
  .nav-side-menu li .sub-menu li.active a {
    color: #d19b3d;
  }
  .nav-side-menu ul .sub-menu li,
  .nav-side-menu li .sub-menu li {
    background-color: #181c20;
    border: none;
    line-height: 28px;
    border-bottom: 1px solid #23282e;
    margin-left: 0px;
  }
  .nav-side-menu ul .sub-menu li:hover,
  .nav-side-menu li .sub-menu li:hover {
    background-color: #020203;
  }
  .nav-side-menu ul .sub-menu li:before,
  .nav-side-menu li .sub-menu li:before {
    font-family: FontAwesome;
    content: "\f105";
    display: inline-block;
    padding-left: 10px;
    padding-right: 10px;
    vertical-align: middle;
  }
  .nav-side-menu li {
    padding-left: 0px;
    border-left: 3px solid #2e353d;
    border-bottom: 1px solid #23282e;
  }
  .nav-side-menu li a {
    text-decoration: none;
    color: #e1ffff;
  }
  .nav-side-menu li a i {
    padding-left: 10px;
    width: 20px;
    padding-right: 20px;
  }
  .nav-side-menu li:hover {
    border-left: 3px solid #d19b3d;
    background-color: #4f5b69;
    -webkit-transition: all 1s ease;
    -moz-transition: all 1s ease;
    -o-transition: all 1s ease;
    -ms-transition: all 1s ease;
    transition: all 1s ease;
  }
  @media (max-width: 767px) {
    .nav-side-menu {
      position: relative;
      width: 100%;
      margin-bottom: 10px;
    }
    .nav-side-menu .toggle-btn {
      display: block;
      cursor: pointer;
      position: absolute;
      right: 10px;
      top: 10px;
      z-index: 10 !important;
      padding: 3px;
      background-color: #ffffff;
      color: #000;
      width: 40px;
      text-align: center;
    }
    .brand {
      text-align: left !important;
      font-size: 22px;
      padding-left: 20px;
      line-height: 50px !important;
    }
  }
  @media (min-width: 767px) {
    .nav-side-menu .menu-list .menu-content {
      display: block;
    }
  }
  @media (max-width: 573px){
    .mobile-div{
      padding: 2px 0px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Partnership/LesseePage.vue